import React from "react";
import ReactDOM from "react-dom";
import ProviderSearch from "../components/ProviderSearch";
import { ProviderSearchProps } from "../components/ProviderSearch/types";

document.addEventListener("DOMContentLoaded", () => {
  const providerSearchRoot = document.querySelector("#provider-search-root");
  const { gaTrackingId }: ProviderSearchProps = {
    gaTrackingId: providerSearchRoot?.getAttribute("data-gatrackingid") || "",
  };

  if (providerSearchRoot) {
    ReactDOM.render(
      <ProviderSearch gaTrackingId={gaTrackingId} />,
      providerSearchRoot.appendChild(document.createElement("div"))
    );
  }
});
